<!-- Unused legacy generic layout. Destination previews are registered by their owning pages. -->
<script>
import Card from 'primevue/card';
import Skeleton from 'primevue/skeleton';

export default {
  components: {
    Card,
    Skeleton,
  },
};
</script>

<template>
  <section
    class="shop-management-content-skeleton"
    role="status"
    aria-live="polite"
    aria-label="Loading page content"
  >
    <div class="shop-management-content-skeleton-header">
      <div class="shop-management-content-skeleton-heading">
        <Skeleton width="min(var(--p-bayhive-skeleton-heading-width), 70%)" height="var(--p-bayhive-skeleton-heading-height)" />
        <Skeleton width="min(var(--p-bayhive-skeleton-description-width), 92%)" height="var(--p-bayhive-skeleton-text-height)" />
      </div>

      <div class="shop-management-content-skeleton-actions">
        <Skeleton width="var(--p-bayhive-skeleton-action-width)" height="var(--p-bayhive-skeleton-control-height)" borderRadius="var(--p-bayhive-skeleton-card-border-radius)" />
        <Skeleton width="var(--p-bayhive-skeleton-wide-action-width)" height="var(--p-bayhive-skeleton-control-height)" borderRadius="var(--p-bayhive-skeleton-card-border-radius)" />
      </div>
    </div>

    <div class="shop-management-content-skeleton-summary">
      <Card
        v-for="index in 3"
        :key="'summary-' + index"
        class="shop-management-content-skeleton-card"
      >
        <template #content>
          <Skeleton width="40%" height="var(--p-bayhive-skeleton-summary-label-height)" />
          <Skeleton width="65%" height="var(--p-bayhive-skeleton-summary-value-height)" />
          <Skeleton width="52%" height="var(--p-bayhive-skeleton-summary-label-height)" />
        </template>
      </Card>
    </div>

    <Card class="shop-management-content-skeleton-panel">
      <template #content>
        <div class="shop-management-content-skeleton-toolbar">
          <Skeleton width="min(var(--p-bayhive-skeleton-toolbar-width), 55%)" height="var(--p-bayhive-skeleton-control-height)" borderRadius="var(--p-bayhive-skeleton-card-border-radius)" />
          <Skeleton width="var(--p-bayhive-skeleton-action-width)" height="var(--p-bayhive-skeleton-control-height)" borderRadius="var(--p-bayhive-skeleton-card-border-radius)" />
        </div>

        <div class="shop-management-content-skeleton-table" aria-hidden="true">
          <div
            v-for="row in 6"
            :key="'row-' + row"
            class="shop-management-content-skeleton-row"
          >
            <Skeleton v-for="column in 4" :key="column" width="100%" height="var(--p-bayhive-skeleton-text-height)" />
          </div>
        </div>
      </template>
    </Card>
  </section>
</template>

<style scoped>
.shop-management-content-skeleton {
  display: grid;
  gap: var(--p-bayhive-spacing-lg);
  width: 100%;
}

.shop-management-content-skeleton-header,
.shop-management-content-skeleton-actions,
.shop-management-content-skeleton-toolbar {
  display: flex;
  align-items: center;
  gap: var(--p-bayhive-spacing-md);
}

.shop-management-content-skeleton-header,
.shop-management-content-skeleton-toolbar {
  justify-content: space-between;
}

.shop-management-content-skeleton-heading {
  display: grid;
  flex: 1 1 auto;
  gap: var(--p-bayhive-spacing-sm);
  min-width: 0;
}

.shop-management-content-skeleton-actions {
  flex: 0 0 auto;
}

.shop-management-content-skeleton-summary {
  display: grid;
  gap: var(--p-bayhive-spacing-lg);
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.shop-management-content-skeleton-card,
.shop-management-content-skeleton-panel {
  border: 1px solid var(--p-content-border-color, var(--p-surface-200));
  box-shadow: none;
}

.shop-management-content-skeleton-card :deep(.p-card-content) {
  display: grid;
  gap: var(--p-bayhive-spacing-md);
}

.shop-management-content-skeleton-panel :deep(.p-card-content) {
  display: grid;
  gap: var(--p-bayhive-spacing-lg);
}

.shop-management-content-skeleton-table {
  display: grid;
}

.shop-management-content-skeleton-row {
  display: grid;
  gap: var(--p-bayhive-spacing-lg);
  grid-template-columns: minmax(var(--p-bayhive-skeleton-primary-column-min-width), 1.5fr) repeat(3, minmax(var(--p-bayhive-skeleton-column-min-width), 1fr));
  padding: var(--p-bayhive-spacing-lg) 0;
}

.shop-management-content-skeleton-row + .shop-management-content-skeleton-row {
  border-top: 1px solid var(--p-content-border-color, var(--p-surface-200));
}

@media (max-width: 767.98px) {
  .shop-management-content-skeleton-header {
    align-items: stretch;
    flex-direction: column;
  }

  .shop-management-content-skeleton-actions {
    display: none;
  }

  .shop-management-content-skeleton-summary {
    grid-template-columns: 1fr;
  }

  .shop-management-content-skeleton-card:nth-child(n + 3) {
    display: none;
  }

  .shop-management-content-skeleton-toolbar > :last-child {
    display: none;
  }

  .shop-management-content-skeleton-row {
    grid-template-columns: minmax(var(--p-bayhive-skeleton-primary-column-min-width), 1.5fr) minmax(var(--p-bayhive-skeleton-column-min-width), 1fr);
  }

  .shop-management-content-skeleton-row > :nth-child(n + 3) {
    display: none;
  }
}
</style>
